import { render } from "./TTSView.vue?vue&type=template&id=02dd7646&scoped=true"
import script from "./TTSView.vue?vue&type=script&lang=js"
export * from "./TTSView.vue?vue&type=script&lang=js"

import "./TTSView.vue?vue&type=style&index=0&id=02dd7646&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02dd7646"]])

export default __exports__